import React, { useEffect, useState } from 'react';
import './InstagramProjects.css';
import { trackInstagramClick } from '../../utils/analytics';
import video1Thumb from '../../assets/insta thumbnails/video1.png';
import video2Thumb from '../../assets/insta thumbnails/video2.png';
import video3Thumb from '../../assets/insta thumbnails/video3.png';
import video4Thumb from '../../assets/insta thumbnails/video4.png';
import video5Thumb from '../../assets/insta thumbnails/video5.png';
import video6Thumb from '../../assets/insta thumbnails/video6.png';

interface InstagramProject {
  id: string;
  videoUrl: string;
  thumbnailUrl: string;
  caption: string;
  instagramLink: string;
}

const InstagramProjects: React.FC = () => {
  // Instagram reel shortcodes from @clevrautomations with local thumbnails
  const instagramPosts = [
    { shortcode: 'C7qm8R5B8tu', caption: 'Smart Home Automation Project', thumbnail: video1Thumb },
    { shortcode: 'CwPh6SJoHNa', caption: 'Modern Smart Lighting Solution', thumbnail: video2Thumb },
    { shortcode: 'Ct12njlIggX', caption: 'Automated Security System', thumbnail: video3Thumb },
    { shortcode: 'DTUWN_Uis-3', caption: 'Smart Door Lock Installation', thumbnail: video4Thumb },
    { shortcode: 'DTO5fZXCvkJ', caption: 'Smart Switch Integration', thumbnail: video5Thumb },
    { shortcode: 'DSA2CUkjLsU', caption: 'Complete Home Automation', thumbnail: video6Thumb }
  ];

  const [projects, setProjects] = useState<InstagramProject[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Use local thumbnail images
    const projectsData: InstagramProject[] = instagramPosts.map(post => {
      const instagramUrl = `https://www.instagram.com/reel/${post.shortcode}/`;
      
      return {
        id: post.shortcode,
        videoUrl: instagramUrl,
        thumbnailUrl: post.thumbnail,
        caption: post.caption,
        instagramLink: instagramUrl
      };
    });

    setProjects(projectsData);
  }, []);

  const handleProjectClick = (instagramLink: string, projectId: string, caption: string) => {
    trackInstagramClick(projectId, caption);
    window.open(instagramLink, '_blank', 'noopener,noreferrer');
  };

  if (loading) {
    return (
      <section className="instagram-projects" id="projects">
        <div className="container">
          <div className="projects-header">
            <h2 className="projects-title">Explore Some of Our Projects</h2>
            <p className="projects-subtitle">Loading Instagram videos...</p>
          </div>
          <div className="projects-grid">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="project-card skeleton">
                <div className="project-image-wrapper">
                  <div className="skeleton-image"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="instagram-projects" id="projects">
      <div className="container">
        <div className="projects-header">
          <h2 className="projects-title">Explore Some of Our Projects</h2>
          <p className="projects-subtitle">
            Follow us on Instagram{' '}
            <a 
              href="https://www.instagram.com/clevrautomations/?hl=en" 
              target="_blank" 
              rel="noopener noreferrer"
              className="instagram-handle"
            >
              @clevrautomations
            </a>
            {' '}to see more luxury smart home automation in Colombo
          </p>
          <div className="projects-hashtags">
            #CLEVR #CLEVRautomation #SmartHomeColombo #LuxurySmartHome #SmartHomeSriLanka
          </div>
        </div>

        <div className="projects-grid">
          {projects.map((project) => (
            <div 
              key={project.id} 
              className="project-card"
              onClick={() => handleProjectClick(project.instagramLink, project.id, project.caption)}
            >
              <div className="project-image-wrapper">
                <img 
                  src={project.thumbnailUrl} 
                  alt={project.caption}
                  className="project-image"
                  onError={(e) => {
                    // Fallback to a placeholder if image doesn't load
                    e.currentTarget.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect width="400" height="400" fill="%23f0f0f0"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="sans-serif" font-size="18" fill="%23999"%3EInstagram Video%3C/text%3E%3C/svg%3E';
                  }}
                />
                <div className="video-badge">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
                <div className="project-overlay">
                  <div className="play-icon">
                    <svg 
                      width="60" 
                      height="60" 
                      viewBox="0 0 24 24" 
                      fill="white"
                    >
                      <circle cx="12" cy="12" r="10" fill="rgba(255,255,255,0.3)"/>
                      <path d="M10 8l6 4-6 4V8z" fill="white"/>
                    </svg>
                  </div>
                  <p className="project-caption">{project.caption}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="view-more">
          <a 
            href="https://www.instagram.com/clevrautomations/?hl=en" 
            target="_blank" 
            rel="noopener noreferrer"
            className="view-more-btn"
          >
            View More on Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramProjects;
